import {useState} from 'react';
import {Button, Segmented} from '@vector';
import styles from './PricingPanel.module.css';

/**
 * Pricing card for brands that sell a choice of packages at prices written in their content: Cambridge LANTITE Edge's
 * bundle of both components or a single one (`content.options`).
 *
 * Same card as `PricingPanel`, with the switch choosing between the brand's packages rather than schools and home,
 * and nothing fetched: the old page wrote these prices out too.
 */
export default function PriceOptionsPanel({id, content, contactEmail}) {
    const [selected, setSelected] = useState(content.options[0].label);
    const option = content.options.find((candidate) => candidate.label === selected) || content.options[0];
    const email = contactEmail || content.contactEmail;

    return (
        <div id={id} className={styles.card}>
            <div className={styles.head}>
                <h2 className={styles.heading}>{content.heading}</h2>
                <Segmented
                    size="large"
                    options={content.options.map((candidate) => ({label: candidate.label, value: candidate.label}))}
                    value={option.label}
                    onChange={setSelected}
                    aria-label="Which package?"/>
            </div>

            {content.body && <p className={styles.hint}>{content.body}</p>}

            <div className={styles.figure}>
                <p className={styles.price}>{option.price}</p>
                <p className={styles.priceNote}>{option.note}</p>
            </div>

            <div className={styles.footer}>
                <Button surface="base" size="large" href={content.action.href}>
                    {content.action.label}
                </Button>
                {email && (
                    <p className={styles.hint}>
                        <a href={`mailto:${email}`}>Email us</a> for more information.
                    </p>
                )}
            </div>
        </div>
    );
}
